import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SiteHeader, { SiteFooter } from "@/components/site/SiteHeader";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import RequestDetail from "@/pages/RequestDetail";
import BookGroup from "@/pages/BookGroup";
import BookingStatus from "@/pages/BookingStatus";
import About from "@/pages/About";
import Login from "@/pages/Login";
import AdminHome from "@/pages/AdminHome";
import EmployeePortal from "@/pages/EmployeePortal";
import { loadUser } from "@/lib/api";

function Protected({ role, children }) {
  const u = loadUser();
  if (!u) return <Navigate to="/login" replace />;
  if (role && u.role !== role && !(role === "staff" && (u.role === "admin" || u.role === "employee")))
    return <Navigate to="/" replace />;
  return children;
}

function PublicShell({ children }) {
  return (
    <div className="App carbon-bg">
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
    </div>
  );
}

export default function App() {
  return (
    <>
      <Toaster position="top-right" theme="dark" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicShell><Home /></PublicShell>} />
          <Route path="/services" element={<PublicShell><Services /></PublicShell>} />
          <Route path="/book" element={<PublicShell><RequestDetail /></PublicShell>} />
          <Route path="/group" element={<PublicShell><BookGroup /></PublicShell>} />
          <Route path="/about" element={<PublicShell><About /></PublicShell>} />
          <Route path="/booking/:token" element={<PublicShell><BookingStatus /></PublicShell>} />
          <Route path="/login" element={<PublicShell><Login /></PublicShell>} />
          <Route path="/admin/*" element={<Protected role="admin"><AdminHome /></Protected>} />
          <Route path="/employee/*" element={<Protected role="staff"><EmployeePortal /></Protected>} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
